<template>
  <div  class="tags-view-container" style="">
      <layout-header></layout-header>

  </div>
</template>

<script>

import layoutHeader from '@/components/common/tabNav';
import NavMessage from "../../components/message/NavMessage";


export default {
  components: {
    NavMessage,
    layoutHeader,
  },
  watch: {
    // 监听浏览器直接输入路由，将此路由添加到tabnavBox
    '$route.path': function (val) {
      this.selectmenu(this.$route.fullPath);
    }
  },
  methods: {
    selectmenu(key) {
      let router = this.$store.state.menus;
      let name = false;
      let _this = this;

      let navTitle2 = function (fullPath) {
        // 没有菜单的页面获取标题
        let path = '';
        if (fullPath.indexOf('?') != -1) {
          path = fullPath.slice(0, fullPath.indexOf('?')); // 去掉参数
        } else {
          path = fullPath;
        }
        _this.$store.state.tabnavBox.forEach(item => {
          // path有带参数并且参数不同时
          if (item.path && item.path.indexOf('?') != -1 && item.path.slice(0, fullPath.indexOf('?')) === path && item.path !== fullPath) {
            item.path = fullPath; // 重新赋值
            name = item.title;
          } else {
            let p = _this.$store.state.noMenuPages.filter(v => v.path === path);
            if (p && p.length > 0) name = p[0].title;
          }
        });
        return name;
      };

      let navTitle = function (path, routerARR) {
        // 左边菜单页面获取标题
        for (let i = 0; i < routerARR.length; i++) {
          if (routerARR[i].children.length > 0 || routerARR[i].path === path) {
            if (routerARR[i].path === path) {
              name = routerARR[i].name;
              break;
            }
            navTitle(path, routerARR[i].children);
          }
        }
        return name;
      };


      let node = false;
      let navLeftMenu = function (path, routerARR, preNode) {
        // 左边菜单页面获取标题
        for (let i = 0; i < routerARR.length; i++) {
          if (path && path.indexOf("?") != -1) {
            path = path.substring(0, path.indexOf("?"));
          }

          if (routerARR[i].children.length > 0 || routerARR[i].path === path) {
            if (routerARR[i].path === path) {
              node = {};
              node.preNode = preNode;
              node.name = routerARR[i].name;
              break;
            }
            let cNode = {
              preNode: preNode,
              name: routerARR[i].name
            }
            navLeftMenu(path, routerARR[i].children, cNode);
          }
        }
        return node;
      };

      if (!key.startsWith('http')) {
        let clearTabNav = true;
        let title = undefined;

        let cNode = navLeftMenu(key, router);
        let preNode = undefined;

        if (!cNode) {
          clearTabNav = this.$route.query.clearTabNav;
          title = navTitle2(key);
        } else {
          title = cNode.name;
          preNode = cNode.preNode;
        }

        _this.$store.dispatch('addTab', {
          title: title,
          path: key,
          clearTabNav: clearTabNav,
          preNode: preNode
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 35px;
  width: 100%;
  //line-height: 28px;
  padding-left: 30px;
  padding-left: calc(6% +  170px);
  background-color: #F1F1F1;
  border: #F1F1F1 1px solid;
  transition: margin-left .28s;
}
.hideSidebar .tags-view-container {
  padding-left: calc(5%)
}
</style>




// WEBPACK FOOTER //
// src/layout/components/Breadcrumb.vue